package com.milta.core.localization.translations.pl

import com.milta.core.localization.SubscriptionStrings

internal val Subscription = SubscriptionStrings(
    screenTitle = "Moja subskrypcja",
    screenSubtitle = "Zarządzaj subskrypcją Milta",
    planDriver = "Kierowca",
    planOrganisation = "Firma",
    statusActive = "Aktywna",
    statusTrial = "Okres próbny",
    statusExpired = "Wygasła",
    statusCancelled = "Anulowana",
    platformLabel = "Platforma",
    productIdLabel = "Produkt",
    expiresAtLabel = "Wygasa",
    noExpiry = "Bez daty wygaśnięcia",
    noValue = "—",
    noSubscription = "Brak aktywnej subskrypcji",
    activateButton = "Aktywuj subskrypcję",
    successActivated = "Subskrypcja aktywowana pomyślnie",
    perMonth = "/miesiąc",
    pitchTitle = "Odblokuj wszystkie funkcje Milta",
    pitchSubtitle = "Wybierz plan odpowiedni dla Twojej działalności, aby kontynuować dostawy i zarządzanie trasami.",
    featuredBadge = "WSZYSTKO W CENIE",
    driverFeature1 = "Nielimitowane trasy i dostawy",
    driverFeature2 = "Zdjęcie potwierdzające dostawę + podpis",
    driverFeature3 = "Powiadomienia w czasie rzeczywistym",
    orgFeature1 = "Nielimitowane zarządzanie zespołem",
    orgFeature2 = "Pełny panel internetowy",
    orgFeature3 = "Import tras (Excel, PDF, zdjęcie)",
    orgFeature4 = "Dostęp Kierowcy dołączony dla Ciebie",
    purchaseFinePrint = "Bezpieczna płatność przez sklep. Możliwość anulowania w każdej chwili z ustawień sklepu.",
    purchasingLabel = "Przetwarzanie…",
    activeCaption = "Twoja subskrypcja Milta",
    nextRenewalLabel = "Następne odnowienie",
    includedTitle = "W ramach Twojego planu",
    manageOnGooglePlay = "Zarządzaj w Google Play",
    manageOnAppStore = "Zarządzaj w App Store",
    viewTechnicalDetails = "Zobacz szczegóły techniczne",
    monthNames = listOf("styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"),
    errorNotFound = "Nie znaleziono aktywnej subskrypcji",
    errorConflict = "Dla tego konta istnieje już aktywna subskrypcja",
    errorPlanMismatch = "Wybrany plan nie odpowiada roli Twojego konta",
    errorPlanRequired = "Wybierz plan",
    errorPlanInvalid = "Wybrany plan jest nieprawidłowy",
    errorPlatformRequired = "Platforma jest wymagana",
    errorPlatformInvalid = "Nieprawidłowa platforma. Musi być AppStore lub GooglePlay",
    errorStoreProductIdRequired = "Identyfikator produktu sklepu jest wymagany",
    errorReceiptTokenRequired = "Token paragonu jest wymagany",
    errorGeneric = "Wystąpił błąd. Spróbuj ponownie.",
    trialBannerDaysPrefix = "🎉 Darmowy okres próbny: zostało Ci ",
    trialBannerDaysBold = "%d dni",
    trialBannerDaysSuffix = " na poznanie Milta bez zobowiązań.",
    trialBannerHoursPrefix = "⏰ Twój darmowy okres próbny kończy się za ",
    trialBannerHoursBold = "%d godz.",
    trialBannerHoursSuffix = ": zasubskrybuj, aby dalej korzystać z Milta bez przerwy.",
)
